import React from "react";

// Reusable Yes/No toggle (copied from Step 4)
const YesNoToggle = ({ name, value, onChange, label }) => {
  return (
    <div className="mt-4">
      <label className="d-block mb-1">
        {label} <span className="text-danger">*</span>
      </label>
      <div className="btn-group w-100" role="group">
        <input
          type="radio"
          className="btn-check"
          name={name}
          id={`${name}_yes`}
          value="Yes"
          checked={value === "Yes"}
          onChange={onChange}
          required
        />
        <label className="btn btn-outline-primary px-5" htmlFor={`${name}_yes`}>
          Yes
        </label>

        <input
          type="radio"
          className="btn-check"
          name={name}
          id={`${name}_no`}
          value="No"
          checked={value === "No"}
          onChange={onChange}
        />
        <label
          className="btn btn-outline-secondary px-5"
          htmlFor={`${name}_no`}
        >
          No
        </label>
      </div>
    </div>
  );
};

const Step6DriverQuestions = ({ form, handleChange, prevStep, nextStep }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (e.target.checkValidity()) {
      nextStep(); // only go forward if valid
    }
  };
  return (
    <form onSubmit={handleSubmit}>
      <fieldset className="border p-3 mb-4">
        <legend>Driver Licence Questions</legend>

        {/* Commercial license date */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label>
              When did you obtain your Commercial Driver’s Licence or plan to do
              so? <span className="text-danger">*</span>
            </label>
            <input
              type="date"
              className="form-control"
              name="dq_commercial_license_date"
              value={form.dq_commercial_license_date || ""}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* License denied */}
        <YesNoToggle
          name="dq_license_denied"
          value={form.dq_license_denied}
          onChange={handleChange}
          required
          label="Have you ever been denied a licence, permit or privilege to operate a motor vehicle?"
        />

        {/* License Denied Explanation */}
        {form.dq_license_denied === "Yes" && (
          <div className="mt-1">
            <label>
              Please Explain <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              name="dq_denied_explanation"
              value={form.dq_denied_explanation}
              onChange={handleChange}
              required
            />
          </div>
        )}
        {/* Abstract clean */}
        <YesNoToggle
          name="dq_abstract_clean"
          value={form.dq_abstract_clean}
          onChange={handleChange}
          required
          label="Do you have a clean abstract and driving record?"
        />

        {form.dq_abstract_clean === "No" && (
          <div className="mb-1">
            <label>
              Please Explain <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              rows="3"
              name="dq_abstract_explanation"
              value={form.dq_abstract_explanation || ""}
              onChange={handleChange}
              required
            ></textarea>
          </div>
        )}

        {/* License suspended */}
        <YesNoToggle
          name="dq_license_suspended"
          value={form.dq_license_suspended}
          onChange={handleChange}
          required
          label="Has any licence, permit or privilege ever been suspended or revoked?"
        />

        {form.dq_license_suspended === "Yes" && (
          <div className="mb-1">
            <label>
              Please Explain <span className="text-danger">*</span>
            </label>
            <textarea
              className="form-control"
              name="dq_suspended_explanation"
              value={form.dq_suspended_explanation}
              onChange={handleChange}
              required
            />
          </div>
        )}

        <div className="d-flex justify-content-between">
          <button className="btn btn-secondary mt-3" onClick={prevStep}>
            ← Back
          </button>
          <button type="submit" className="btn btn-primary mt-3">
            Next →
          </button>
        </div>
      </fieldset>
    </form>
  );
};

export default Step6DriverQuestions;
